import React, { useMemo } from 'react';
import { ostGridDotSpacing, ostGridDotRadius, ostGridDotColor, ostGridDotOpacity } from 'theme';

type Props = {
    spacing?: number; // distance between dots in canvas units
    radius?: number;
    color?: string;
    opacity?: number;
    extent?: number; // half-width/height of the square region to cover (canvas units)
};

export default function GridLayer({
    spacing = ostGridDotSpacing,
    radius = ostGridDotRadius,
    color = ostGridDotColor,
    opacity = ostGridDotOpacity,
    extent = 4000,
}: Props) {
    // unique id so multiple canvases won't collide
    const id = useMemo(() => `dot-grid-${Math.random().toString(36).slice(2, 9)}`, []);

    // pattern is small and repeated by the renderer; a single rect filled with it is cheap
    return (
        <g className="canvas-grid" pointerEvents="none" aria-hidden="true">
            <defs>
                <pattern id={id} patternUnits="userSpaceOnUse" width={spacing} height={spacing}>
                    <circle cx={spacing / 2} cy={spacing / 2} r={radius} fill={color} opacity={opacity} />
                </pattern>
            </defs>
            <rect x={-extent} y={-extent} width={extent * 2} height={extent * 2} fill={`url(#${id})`} />
        </g>
    );
}
